import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../../utils/api"
import { getErrorMessage } from "../../../utils/helpers/errors";

export const useRetroAdjustmentApi = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { authPost } = useApi();

    const create = useCallback(async (data, onSuccess, onFailure) => {
        setLoading(true);
        try {
            const response = await authPost("/retro-adjustment", { data });
            onSuccess?.(response);
        } catch (err) {
            getErrorMessage(err, t);
            onFailure?.();
            setLoading(false);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [authPost, t]);

    return { create, error, loading };
}
